import './App.css';
import React, { useCallback, useEffect, useState } from 'react';
import Slider from 'react-slick';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faPhone, faGlobe, faTimes } from '@fortawesome/free-solid-svg-icons';
import ott01 from './img/myflix01.webp';
import ott02 from './img/myflix02.webp';
import ott03 from './img/myflix03.webp';
import ytb1 from './img/ytb01.webp';
import ytb2 from './img/ytb02.webp';
import ytb3 from './img/ytb03.webp';
import chatlive01 from './img/chatlive01.webp';
import chatlive02 from './img/chatlive02.webp';
import chatlive03 from './img/chatlive03.webp';
import openquiz1 from './img/openquiz1.webp';
import openquiz2 from './img/openquiz2.webp';
import openquiz3 from './img/openquiz3.webp';
import weaterLive1 from './img/weather1.webp';
import weaterLive2 from './img/weather2.webp';
import epilog1 from './img/epilog01.webp';
import epilog2 from './img/epilog02.webp';
import epilog3 from './img/epilog03.webp';

import segly1 from './img/segly1.webp';
import segly2 from './img/segly2.webp';
import segly3 from './img/segly3.webp';


import fireview1 from './img/fireview1.webp';
import fireview2 from './img/fireview2.webp';
import fireview3 from './img/fireview3.webp';


import scrapicker1 from './img/scrapicker1.webp';
import scrapicker2 from './img/scrapicker2.webp';
import scrapicker3 from './img/scrapicker3.webp';

import AOS from 'aos';
import 'aos/dist/aos.css';

export const tagSvgs = {
  html: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 9L5 12L8 15" />
      <path d="M16 9L19 12L16 15" />
      <path d="M14 8L10 16" />
    </svg>
  ),

  css: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="2.5" y="5.5" width="19" height="13" rx="3.5" />
      <text
        x="12"
        y="12.2"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="8.4"
        fontWeight="900"
        letterSpacing="1.3"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.35"
        paintOrder="stroke"
        fontFamily="ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial"
      >
        CSS
      </text>
    </svg>
  ),

  javascript: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <path d="M10.5 8.5v7c0 1.1-.9 2-2 2" />
      <path d="M15.8 9.2c-.5-.5-1.1-.7-1.8-.7-1 0-1.8.6-1.8 1.5 0 .8.6 1.2 1.6 1.5l.5.1c1.2.3 2 .9 2 2 0 1.3-1.1 2.2-2.7 2.2-1 0-1.9-.3-2.5-1" />
    </svg>
  ),

  typescript: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <path d="M8 9h8" />
      <path d="M12 9v10" />
    </svg>
  ),

  react: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none" />
      <ellipse cx="12" cy="12" rx="9" ry="4" />
      <ellipse cx="12" cy="12" rx="9" ry="4" transform="rotate(60 12 12)" />
      <ellipse cx="12" cy="12" rx="9" ry="4" transform="rotate(120 12 12)" />
    </svg>
  ),

  next: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M9 16V8l6 8V8" />
    </svg>
  ),

  vue: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 6l8 14L20 6" />
      <path d="M7 6l5 9 5-9" />
    </svg>
  ),

  nuxt: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3.5 19h17" />
      <path d="M5.5 19L11 9l4 7 2-3 3.5 6" />
    </svg>
  ),

  sql: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <ellipse cx="12" cy="6.5" rx="7.5" ry="3.5" />
      <path d="M4.5 6.5V17.5C4.5 19.4 7.9 21 12 21C16.1 21 19.5 19.4 19.5 17.5V6.5" />
      <path d="M4.5 12c0 1.9 3.4 3.5 7.5 3.5S19.5 13.9 19.5 12" />
    </svg>
  ),
};

const PROJECT_TAGS = [
  {
    id: 1,
    name: 'next',
    svg: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
        <path d="M9 16V8L16 16V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    id: 2,
    name: 'react',
    svg: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="2" fill="currentColor" />
        <ellipse cx="12" cy="12" rx="9" ry="4" stroke="currentColor" strokeWidth="1.5" />
        <ellipse cx="12" cy="12" rx="9" ry="4" stroke="currentColor" strokeWidth="1.5" transform="rotate(60 12 12)" />
        <ellipse cx="12" cy="12" rx="9" ry="4" stroke="currentColor" strokeWidth="1.5" transform="rotate(120 12 12)" />
      </svg>
    ),
  },
  {
    id: 3,
    name: 'vercel',
    svg: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3L2 21H22L12 3Z" />
      </svg>
    ),
  },
  {
    id: 4,
    name: 'socket.io',
    svg: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 11a5 5 0 0 1 10 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M4 11a8 8 0 0 1 16 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="16.5" r="1.5" fill="currentColor" />
      </svg>
    ),
  },
  {
    id: 5,
    name: 'github',
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M12 2C6.477 2 2 6.596 2 12.253c0 4.521 2.865 8.353 6.839 9.706.5.096.682-.223.682-.497 0-.244-.009-.891-.014-1.748-2.782.62-3.369-1.372-3.369-1.372-.454-1.183-1.109-1.498-1.109-1.498-.907-.639.069-.626.069-.626 1.003.073 1.531 1.058 1.531 1.058.892 1.566 2.341 1.114 2.91.852.092-.667.349-1.114.635-1.37-2.221-.259-4.555-1.141-4.555-5.077 0-1.122.39-2.04 1.029-2.758-.103-.26-.446-1.301.098-2.713 0 0 .84-.276 2.75 1.053A9.3 9.3 0 0 1 12 6.844c.85.004 1.705.118 2.503.346 1.909-1.329 2.748-1.053 2.748-1.053.546 1.412.203 2.453.1 2.713.64.718 1.028 1.636 1.028 2.758 0 3.946-2.338 4.815-4.566 5.069.359.317.679.944.679 1.903 0 1.374-.012 2.48-.012 2.818 0 .276.18.598.688.496C19.138 20.602 22 16.772 22 12.253 22 6.596 17.523 2 12 2Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
];

const SKILLS = [
  { icon: 'react', name: 'React', context: '주력 · 상태 관리 중심 개발' },
  { icon: 'next', name: 'Next.js', context: 'App Router 기반 SSR/CSR 경험' },
  { icon: 'typescript', name: 'TypeScript', context: '실무형 타입 설계 및 적용' },
  { icon: 'javascript', name: 'JavaScript', context: '비동기 처리 및 렌더링 최적화' },
  { icon: 'html', name: 'HTML/CSS', context: '시맨틱 마크업과 반응형 UI 구현' },
  { icon: 'sql', name: 'PostgreSQL', context: '기본 모델링 및 데이터 조회' },
  { icon: 'vue', name: 'Vue', context: '기초 프로젝트 구현 경험' },
  { icon: 'nuxt', name: 'Nuxt', context: 'SSR 흐름 학습 및 적용' },
];

const PROFILE_HIGHLIGHTS = [
  {
    title: '실시간 인터랙션 설계',
    desc: '실시간 동기화와 예외 처리를 구조화해 끊김 없는 참여 경험을 만듭니다.',
  },
  {
    title: '상태 관리와 화면 흐름 제어',
    desc: '복합 UI 상태를 단순한 흐름으로 정리해 빠른 개발과 안정적인 운영을 동시에 달성합니다.',
  },
  {
    title: '서비스형 프로젝트 완성 경험',
    desc: '인증, 데이터, 성능까지 실제 서비스 기준으로 설계·개선한 경험을 보유하고 있습니다.',
  },
];

const HERO_FOCUS = ['실시간 서비스', '상태 관리 설계', '배포 중심 프로젝트'];

const CAREER_HISTORY = [
  {
    company: '미래도',
    team: '개발팀',
    role: '프론트엔드 개발',
    period: '2024.11 - 2026.01',
    duration: '1년 3개월',
    highlights: [
      '방송/사용자 탐색 구조를 개선하고 검색 기능을 구현하며 REST API 응답 구조를 정리했습니다.',
      'WebSocket 기반 실시간 채팅 시스템의 상태 동기화와 연결 예외 처리를 설계했습니다.',
      '후원 이벤트의 실시간 UI 반영과 인터랙션 흐름을 구현하고 관리자 페이지 구조를 개선했습니다.',
    ],
  },
  {
    company: '비즈마인',
    team: '퍼블리싱팀',
    role: '퍼블리셔',
    period: '2022.06 - 2024.06',
    duration: '2년 1개월',
    highlights: [
      'HTML/CSS/JavaScript 기반 UI 퍼블리싱과 인터랙션 구현을 담당했습니다.',
      '크로스브라우징 및 반응형 레이아웃을 적용해 다양한 환경에서 화면 일관성을 높였습니다.',
      '공통 UI 패턴을 정리하고 운영/QA 이슈를 반영해 유지보수 효율을 개선했습니다.',
    ],
  },
  {
    company: '모노브레인',
    team: '콘텐츠 제작',
    role: '퍼블리셔',
    period: '2021.07 - 2021.11',
    duration: '5개월',
    highlights: [
      'HTML5 기반 전자 교과서/교육 콘텐츠 퍼블리싱을 수행했습니다.',
      '웹 표준과 접근성을 고려한 구조 설계로 콘텐츠 품질을 안정화했습니다.',
      '크로스브라우징 대응과 ePub 인터랙션 구현으로 사용자 경험을 개선했습니다.',
    ],
  },
];

const WORK_PROJECTS = [
  {
    id: 'miraedo-live-platform',
    company: '미래도',
    projectName: '라이브 스트리밍 플랫폼 구축 · 운영 및 고도화',
    period: '2024.11 - 2026.01',
    role: '플랫폼 오픈부터 운영 고도화까지 프론트엔드 전반 설계·개발',
    team: '기획 3 / 디자인 1 / 백엔드 2 / 프론트엔드 2',
    stack: ['Nuxt.js', 'TypeScript', 'JavaScript', 'REST API', 'WebSocket', 'HLS', 'JWT'],
    highlights: [
      'HLS 플레이어 상태(로딩/버퍼링/재생)를 분리 설계해 시청 UI 일관성을 확보했습니다.',
      'WebSocket 동기화·연결 예외 처리로 실시간 채팅 안정성을 강화했습니다.',
      'JWT 인증/토큰 갱신과 API 처리 구조를 정리해 상태 흐름을 단순화했습니다.',
      '렌더링·리소스 최적화로 Lighthouse 점수를 약 60점에서 85점으로 개선했습니다.',
    ],
    services: [
      { name: '부비 라이브', url: 'https://www.bubeelive.com', visibility: 'public' },
      { name: '부비 라이브 관리자', visibility: 'private', note: '운영 중 내부 시스템으로 비공개' },
    ],
  },
  {
    id: 'bizmine-audit-system',
    company: '비즈마인',
    projectName: '감사 시스템 퍼블리싱 및 프론트엔드 개발',
    period: '2024.01 - 2024.04',
    role: 'Vue.js 기반 프레임워크 내 퍼블리셔 및 프론트엔드 개발',
    stack: ['Vue.js'],
    highlights: [
      '컴포넌트 구조와 데이터 입출력 로직을 정비해 화면 동작 안정성을 확보했습니다.',
      '메뉴/컴포넌트 구조 재설계와 신규 퍼블리싱으로 확장성과 유지보수성을 개선했습니다.',
    ],
    services: [{ name: '고객사 감사 시스템', visibility: 'private', note: '고객사 내부 시스템으로 비공개' }],
  },
  {
    id: 'bizmine-bank-admin',
    company: '비즈마인',
    projectName: '은행 상담 시스템 관리자 UI 퍼블리싱 및 프론트엔드 개발',
    period: '2023.10 - 2024.01',
    role: 'React 기반 프레임워크 내 신규 프로젝트 퍼블리셔 및 프론트엔드 개발',
    stack: ['React'],
    highlights: [
      'React 기반 신규 프로젝트 전 페이지 퍼블리싱을 완료했습니다.',
      '데이터 출력/변환 로직을 정리해 관리자 화면의 데이터 흐름을 안정화했습니다.',
    ],
    services: [{ name: '은행 상담 시스템 관리자', visibility: 'private', note: '내부망 운영 프로그램으로 비공개' }],
  },
];

const PROJECTS = [
  {
    "no": 9,
    "featured": true,
    "pjtName": "불구경",
    "impact": "5분 주기 배치 수집과 fire_score 알고리즘으로 커뮤니티 급상승 이슈를 랭킹화한 서비스",
    "url": "https://www.bulgugyeong.com/",
    "summary": "디시인사이드·에펨코리아 게시글을 수집해 댓글/조회/추천 증감 기반 화력 점수로 정렬해 보여주는 커뮤니티 이슈 대시보드입니다.",
    "subTitle": "커뮤니티 실시간 화력 랭킹 대시보드",
    "detail": {
      "stack": [
        "Next.js App Router",
        "React 19",
        "TypeScript",
        "Playwright",
        "Cheerio",
        "MySQL",
      ],
      "features": [
        "Hot/New 탭, 사이트별 필터, 식은 불 포함 토글 기반 이슈 탐색",
        "무한 스크롤 + 30초 폴링으로 신규 고화력 이슈 알림",
        "실시간 핫 키워드 노출과 게시글 원문 바로가기"
      ],
      "techPoints": [
        "5분 주기 Cron + DB 락(GET_LOCK)으로 중복 배치 실행 방지",
        "조회/추천/댓글의 누적값·증감·속도와 시간 감쇠를 결합한 fire_score 산정",
        "Cheerio 1차 파싱 실패 시 Playwright 재시도 및 스냅샷 동기화(업서트/삭제)로 데이터 안정화"
      ]
    },
    "images": [fireview3, fireview2, fireview1],
    "tags": [1, 3, 4]
  },
  {
    "no": 8,
    "featured": true,
    "pjtName": "Scrapicker",
    "impact": "Playwright 렌더링과 큐 기반 비동기 스캔으로 대형·동적 페이지에서도 이미지/가격/텍스트 추출을 안정화한 서비스",
    "url": "https://scrapicker.com",
    "summary": "URL 입력만으로 서버 렌더 화면을 확인하고, 추출 결과를 JSON/CSV로 즉시 내보낼 수 있는 AI 비주얼 웹 스크래퍼입니다.",
    "subTitle": "Playwright + Queue 기반 AI 비주얼 웹 스크래퍼",
    "detail": {
      "stack": [
        "Next.js App Router",
        "React 19",
        "TypeScript",
        "Playwright",
        "Upstash Redis",
        "Vercel Queue"
      ],
      "features": [
        "URL 입력 후 서버 렌더 미리보기(스크린샷 + bbox 오버레이)",
        "이미지/가격/텍스트 요소 자동 추출 및 뷰포트 연동 리스트",
        "JSON/CSV 다운로드와 스캔 작업 상태 폴링"
      ],
      "techPoints": [
        "Playwright 자동 스크롤 기반 전체 문서 캡처로 무한 스크롤 페이지 대응",
        "Upstash Redis + Vercel Queue 기반 비동기 스캔 파이프라인(queued/processing/succeeded)",
        "저리소스 모드·브라우저 재시작·임시파일 정리로 서버리스 안정성 강화"
      ]
    },
    "images": [scrapicker1, scrapicker2, scrapicker3],
    "tags": [1, 3]
  },
  {
    "no": 7,
    "featured": true,
    "pjtName": "Segly",
    "impact": "투표 작성·정렬·검색·신고와 다국어(ko/en) 전환을 결합한 참여형 커뮤니티 서비스",
    "url": "https://www.segly.co.kr",
    "summary": "로그인 사용자 기준으로 투표를 만들고 참여하며, 댓글까지 이어지는 커뮤니티 흐름을 구현한 웹 서비스입니다.",
    "subTitle": "실시간 투표·커뮤니티 웹 서비스",
    "detail": {
      "stack": ["Next.js App Router", "TypeScript", "MySQL", "Socket.io", "Vercel Blob"],
      "features": ["투표 생성/참여 및 댓글", "투표 정렬/검색과 설명글 지원", "투표·댓글 신고 기능"],
      "techPoints": ["업로드 이미지 WebP 변환 파이프라인", "Header 언어 선택 + 지역 기반 ko/en 라우팅", "SEO 메타데이터/alternate/hreflang 최적화"]
    },
    "images": [segly1,segly2,segly3],
    "tags": [1, 3,4]
  },
  {
    no: 1,
    featured: false,
    pjtName: 'TubeInsight',
    impact: 'YouTube API 캐싱으로 quota 소모를 줄이고 핵심 지표 탐색 속도를 높인 분석 서비스',
    url: 'https://tube-insight-smoky.vercel.app/',
    summary: '검색 기반으로 유튜브 채널 데이터를 빠르게 탐색할 수 있도록 만든 분석형 웹 서비스입니다.',
    subTitle: 'YouTube 채널·영상 데이터를 검색하고 핵심 지표를 확인하는 분석 서비스',
    detail: {
      stack: ['Next.js App Router', 'React 19', 'TypeScript', 'Tailwind CSS', 'YouTube Data API'],
      features: ['채널 검색 및 채널 정보 분석', '구독자/조회수/영상 수 핵심 지표 시각화', '영상 목록 기반 콘텐츠 탐색'],
      techPoints: ['API 응답 캐싱으로 quota 소모 최적화', '검색 상태 기반 데이터 동기화', '로딩/에러 상태 분리로 UX 안정성 확보'],
    },
    images: [ytb1, ytb2, ytb3],
    tags: [1, 3],
  },
  {
    no: 2,
    featured: false,
    pjtName: 'ChatLive',
    impact: 'WebSocket 기반 실시간 메시지 동기화와 자동 스크롤 UX를 구현한 채팅 서비스',
    url: 'https://chat-live-beta.vercel.app/',
    summary: '실시간 통신과 입력 경험에 집중해 메시지 흐름이 끊기지 않도록 설계한 채팅 웹 애플리케이션입니다.',
    subTitle: 'Socket.io 기반 실시간 채팅 서비스',
    detail: {
      stack: ['Next.js App Router', 'React', 'TypeScript', 'Socket.io'],
      features: ['실시간 메시지 송수신', '스페셜 메시지 텍스트 폭죽 애니메이션', 'Shift+Enter 줄바꿈 입력 처리'],
      techPoints: ['소켓 이벤트 기반 메시지 동기화', '새 메시지 도착 시 자동 스크롤 제어', '채팅 입력 UX 개선으로 사용성 강화'],
    },
    images: [chatlive01, chatlive02, chatlive03],
    tags: [1, 3, 4],
  },
  {
    no: 3,
    featured: false,
    pjtName: 'Open Quiz',
    impact: 'OAuth 로그인과 PostgreSQL을 결합해 퀴즈 생성-풀이-결과 저장 플로우를 완성한 서비스',
    url: 'https://open-quiz-rho.vercel.app/',
    summary: '인증, 데이터 저장, 이미지 업로드를 결합해 실제 서비스 흐름을 구현한 퀴즈 플랫폼입니다.',
    subTitle: '퀴즈 제작·풀기 웹 애플리케이션',
    detail: {
      stack: ['Next.js App Router', 'TypeScript', 'PostgreSQL (Render)', 'NextAuth (Kakao)', 'Vercel Blob'],
      features: ['카테고리별 퀴즈 목록 및 상세/풀이', '퀴즈 생성 (제목·설명·썸네일·문항 이미지)', '퀴즈 결과 저장 및 관리'],
      techPoints: ['카카오 OAuth 기반 인증 흐름 구현', 'DB 중심 퀴즈/결과 데이터 모델 구성', '이미지 업로드 저장소 분리로 확장성 확보'],
    },
    images: [openquiz1, openquiz2, openquiz3],
    tags: [1, 3],
  },
  {
    no: 4,
    featured: false,
    pjtName: 'Epilog',
    impact: '웹툰 탐색부터 감상글 작성·북마크까지 이어지는 사용자 흐름을 구현한 서비스',
    url: 'https://epilog-ten.vercel.app?key=kjmpp',
    summary: '네이버·카카오 웹툰 데이터를 한곳에서 검색하고, 로그인 사용자 기준으로 감상과 평점을 기록·관리할 수 있는 플랫폼입니다.',
    subTitle: '웹툰 감상 기록·탐색 웹 서비스',
    detail: {
      stack: ['Next.js App Router', 'TypeScript', 'MySQL', 'Zustand', 'JWT Authentication'],
      features: ['요일/키워드 기반 웹툰 목록 조회 및 무한 스크롤', '작품 상세에서 평점·재감상 의향·감상글 작성', '북마크 추가/해제 및 마이 북마크 목록 관리'],
      techPoints: ['JWT + 쿠키 기반 인증과 보호 API 접근 제어', '리뷰/북마크 집계 쿼리로 평점·인기 지표 반영', '테이블 자동 생성 로직으로 초기 환경 세팅 단순화'],
    },
    images: [epilog3, epilog2, epilog1],
    tags: [1, 3],
  },
  {
    no: 5,
    featured: false,
    pjtName: 'MYFLIX',
    impact: 'TMDB API 연동과 무한 스크롤/검색/필터를 구현한 콘텐츠 탐색 서비스',
    url: 'https://myflix-sandy.vercel.app',
    summary: '콘텐츠 탐색 패턴 중심으로 UI/UX를 구성한 영화·TV 정보 탐색 웹 애플리케이션입니다.',
    subTitle: '영화·TV 콘텐츠 탐색 웹 애플리케이션',
    detail: {
      stack: ['Next.js App Router', 'React 19', 'TypeScript', 'Tailwind CSS', 'TMDB API'],
      features: ['인기 콘텐츠 리스트와 히어로 배너', '무한 스크롤 기반 목록 탐색', '검색/장르 필터/좋아요(localStorage)'],
      techPoints: ['클라이언트 상태 기반 탐색 UI 구성', '모달 상세 보기와 화면 전환 UX 설계', '콘텐츠 탐색 중심 인터랙션 구현'],
    },
    images: [ott01, ott02, ott03],
    tags: [1, 3],
  },
  {
    no: 6,
    featured: false,
    pjtName: 'Weather Live',
    impact: '실시간 날씨 데이터를 외출 점수로 변환해 의사결정을 돕는 대시보드',
    url: 'https://weather-live-five.vercel.app/',
    summary: '현재 날씨 정보를 직관적인 점수와 배경 변화로 전달해 빠르게 판단할 수 있도록 만든 서비스입니다.',
    subTitle: '날씨를 점수로 번역하는 대시보드',
    detail: {
      stack: ['Next.js', 'React', 'TypeScript', '날씨 API 연동'],
      features: ['위치 기반 현재 날씨 조회', '기온/체감/습도/풍속 기반 외출 점수 계산', '낮/밤·날씨 상태에 따른 배경 자동 전환'],
      techPoints: ['복수 기상 지표를 하나의 점수로 환산', '상태 변화에 따른 동적 배경 렌더링', '정보 전달 우선의 대시보드 UI 구성'],
    },
    images: [weaterLive1, weaterLive2],
    tags: [1, 3],
  },
];

const INITIAL_POPUP_DATA = {
  pjtName: '',
  subTitle: '',
  summary: '',
  impact: '',
  detail: {
    stack: [],
    features: [],
    techPoints: [],
  },
  url: '',
  images: [],
};

function getBrowserId() {
  let id = localStorage.getItem('browser_id');

  if (!id) {
    const canMakeUuid = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function';
    id = canMakeUuid ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem('browser_id', id);
  }

  return id;
}

function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(INITIAL_POPUP_DATA);

  const featuredOrder = ['Open Quiz', 'ChatLive', 'TubeInsight'];
  const featuredProjects = PROJECTS.filter((project) => project.featured).sort(
    (a, b) => featuredOrder.indexOf(a.pjtName) - featuredOrder.indexOf(b.pjtName)
  );
  const otherProjects = PROJECTS.filter((project) => !project.featured);

  const popupShow = (project) => {
    setPopupData(project);
    setShowPopup(true);
    document.body.classList.add('no-scroll');
  };

  const popupHide = useCallback(() => {
    setShowPopup(false);
    setPopupData(INITIAL_POPUP_DATA);
    document.body.classList.remove('no-scroll');
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const scrollToSection = (id) => {
    const target = document.getElementById(id);
    if (!target) {
      return;
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  useEffect(() => {
    AOS.init({
      duration: 550,
      easing: 'ease-out-cubic',
      once: true,
    });

    const id = getBrowserId();

    fetch('https://open-quiz-rho.vercel.app/api/searchAnalytics/research', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id }),
    }).catch(() => undefined);

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  useEffect(() => {
    if (!showPopup) {
      return undefined;
    }

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        popupHide();
      }
    };

    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [showPopup, popupHide]);

  const renderProjectCard = (project) => (
    <li
      key={project.no}
      className={project.featured ? 'featured-project' : 'other-project'}
      onClick={() => popupShow(project)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          popupShow(project);
        }
      }}
      role="button"
      tabIndex={0}
      data-aos="fade-up"
      data-aos-delay="200"
    >
      <div className="thumb">
        {project.images?.[0] ? (
          <img src={project.images[0]} alt={project.pjtName} />
        ) : (
          <div className="thumbPlaceholder" aria-hidden>
            <span>{project.pjtName}</span>
          </div>
        )}
        <div className="thumbOverlay">
          <span className="detailCta">View Detail</span>
        </div>
      </div>
      <div className="exp">
        <div className="titleRow">
          <div className="title">{project.pjtName}</div>
          {project.featured && <span className="badge">대표</span>}
        </div>
        <p className="impact">{project.impact}</p>
        <p className="summary">{project.summary}</p>
        <div className="card_footer">
          <div className="tags">
            {project.tags.map((item) => {
              const tagData = PROJECT_TAGS.find((tag) => tag.id === item);

              return (
                <div className="tag" key={`${project.no}-${item}`}>
                  {tagData?.svg}
                  <div className="text">{tagData?.name}</div>
                </div>
              );
            })}
          </div>
          <span className="open_hint">자세히 보기</span>
        </div>
      </div>
    </li>
  );

  return (
    <div className="App">
      <section className="sec_01" id="top">
        <div className="hero_blur hero_blur_one" />
        <div className="hero_blur hero_blur_two" />
        <div className="container h100">
          <div className="center_box">
            <p className="hero_label" data-aos="fade-up">
              FRONTEND PORTFOLIO
            </p>
            <div className="graphic_wrap">
              <h1 className="hero_title" data-aos="fade-up" data-aos-delay="80">
                안녕하세요, 김정민입니다.
                <span className="hero_tagline">
                  <span className="upAnimate an1">실시간 서비스</span>와{' '}
                  <span className="upAnimate an2">상태 관리</span>를 설계하는 프론트엔드 개발자
                </span>
              </h1>
              <div className="sub_text" data-aos="fade-up" data-aos-delay="160">
                사용자 흐름을 끊지 않는 인터랙션,
                <br />
                확장 가능한 구조, 빠른 전달력을 기준으로 제품을 만듭니다.
              </div>
            </div>

            <ul className="hero_focus" data-aos="fade-up" data-aos-delay="220">
              {HERO_FOCUS.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>

            <div className="hero_stats" data-aos="fade-up" data-aos-delay="280">
              <div className="stat_item">
                <strong>1년 1개월</strong>
                <span>프론트엔드 경력</span>
              </div>
              <div className="stat_item">
                <strong>2년 7개월</strong>
                <span>퍼블리싱 경력</span>
              </div>
              <div className="stat_item">
                <strong>{PROJECTS.length}+</strong>
                <span>배포 프로젝트</span>
              </div>
              <div className="stat_item">
                <strong>{SKILLS.length}</strong>
                <span>핵심 기술 스택</span>
              </div>
            </div>

            <div className="hero_actions" data-aos="fade-up" data-aos-delay="340">
              <button type="button" className="hero_btn primary" onClick={() => scrollToSection('work')}>
                실무 프로젝트 보기
              </button>
              <button type="button" className="hero_btn secondary" onClick={() => scrollToSection('contact')}>
                연락처 보기
              </button>
            </div>
          </div>

          <button type="button" className="about_arrow" onClick={() => scrollToSection('about')}>
            About me
          </button>
        </div>
      </section>

      <section className="sec_02" id="about">
        <div className="container">
          <div className="introduce_wrap">
            <p className="section_label" data-aos="fade-up">
              Profile
            </p>
            <h2 data-aos="fade-up" data-aos-delay="80">
              빠르게 구조화하고, 사용자 입장에서 끝까지 완성합니다.
            </h2>
            <p className="intro_copy" data-aos="fade-up" data-aos-delay="140">
              단순히 화면을 만드는 개발자가 아니라, 실제 사용 흐름에서 끊김이 없는 제품 경험을 설계하려고 합니다.
              <br />
              기능 구현과 UX 완성도를 함께 챙겨서 팀이 바로 활용할 수 있는 결과물을 만드는 데 집중합니다.
            </p>

            <ul className="strength_list" data-aos="fade-up" data-aos-delay="200">
              {PROFILE_HIGHLIGHTS.map((item) => (
                <li key={item.title}>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="skills_wrap">
            <h3 className="skills_title" data-aos="fade-up">
              Skills
            </h3>
            <ul className="skill_list" data-aos="fade-up" data-aos-delay="200">
              {SKILLS.map((skill) => (
                <li key={skill.name}>
                  {tagSvgs[skill.icon]}
                  <div className="skill_text">
                    <div className="skill_name">{skill.name}</div>
                    <div className="skill_context">{skill.context}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="career_wrap">
            <h3 className="career_title" data-aos="fade-up">
              Career
            </h3>
            <p className="career_intro" data-aos="fade-up" data-aos-delay="80">
              퍼블리싱부터 프론트엔드 개발까지, 사용자 흐름과 안정성을 함께 개선해 온 경력입니다.
            </p>
            <ul className="career_list">
              {CAREER_HISTORY.map((career, index) => (
                <li key={career.company} data-aos="fade-up" data-aos-delay={120 + index * 60}>
                  <div className="career_top">
                    <div>
                      <h4>{career.company}</h4>
                      <p className="career_team">{career.team}</p>
                    </div>
                    <div className="career_meta">
                      <p>{career.period}</p>
                      <span>{career.duration}</span>
                    </div>
                  </div>
                  <p className="career_role">{career.role}</p>
                  <ul className="career_points">
                    {career.highlights.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="sec_work" id="work">
        <div className="container">
          <p className="section_label" data-aos="fade-up">
            Work Projects
          </p>
          <h2 className="work_title" data-aos="fade-up" data-aos-delay="80">
            실무 프로젝트
          </h2>
          <p className="work_intro" data-aos="fade-up" data-aos-delay="140">
            프론트엔드로 참여한 운영 프로젝트 중, 성능 및 안정성 개선 사례를 중심으로 정리했습니다.
          </p>

          <ul className="work_list">
            {WORK_PROJECTS.map((project, index) => (
              <li key={project.id} data-aos="fade-up" data-aos-delay={180 + index * 60}>
                <div className="work_head">
                  <div>
                    <p className="work_company">{project.company}</p>
                    <h3>{project.projectName}</h3>
                  </div>
                  <p className="work_period">{project.period}</p>
                </div>

                <p className="work_role">
                  <span>담당 역할</span>
                  {project.role}
                </p>

                {project.team && (
                  <p className="work_team">
                    <span>개발 인원</span>
                    {project.team}
                  </p>
                )}

                <div className="work_stack">
                  {project.stack.map((tech) => (
                    <span key={`${project.id}-${tech}`}>{tech}</span>
                  ))}
                </div>

                <ul className="work_points">
                  {project.highlights.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>

                <div className="work_services">
                  {project.services.map((service) =>
                    service.visibility === 'public' ? (
                      <a key={service.name} href={service.url} target="_blank" rel="noreferrer">
                        {service.name}
                      </a>
                    ) : (
                      <p key={service.name} className="private">
                        <strong>{service.name}</strong>
                        <span>{service.note}</span>
                      </p>
                    )
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="sec_03" id="projects">
        <div className="project_wrap">
          <div className="container">
            <p className="section_label light" data-aos="fade-up">
              Projects
            </p>
            <h2 data-aos="fade-up" data-aos-delay="80">
              Personal Projects
            </h2>
            <p className="project_intro" data-aos="fade-up" data-aos-delay="150">
              기획부터 구현, 배포까지 직접 진행한 프로젝트입니다.
              <br />
              문제 해결 방식과 기술 선택 근거가 드러나도록 정리했습니다.
            </p>
          </div>

          <div className="project-inner">
            <div className="container">
              <div className="project_group">
                <h3 className="project_group_title" data-aos="fade-up">
                  대표 프로젝트 <span>{featuredProjects.length}</span>
                </h3>
                <ul className="prject_list featured">{featuredProjects.map((project) => renderProjectCard(project))}</ul>
              </div>

              <div className="project_group">
                <h3 className="project_group_title other" data-aos="fade-up">
                  기타 프로젝트 <span>{otherProjects.length}</span>
                </h3>
                <ul className="prject_list secondary">{otherProjects.map((project) => renderProjectCard(project))}</ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sec_04" id="contact">
        <div className="container">
          <p className="section_label" data-aos="fade-up">
            Contact
          </p>
          <h2 className="contact_title" data-aos="fade-up" data-aos-delay="80">
            협업을 통해 더 좋은 제품을 만들 준비가 되어 있습니다.
          </h2>
          <div className="contact-wrap" data-aos="fade-up" data-aos-delay="180">
            <div className="contact-item">
              <FontAwesomeIcon icon={faUser} />
              <span>김정민</span>
            </div>
            <div className="contact-item">
              <FontAwesomeIcon icon={faPhone} />
              <span>010-8520-5542</span>
            </div>
            <div className="contact-item">
              <FontAwesomeIcon icon={faEnvelope} />
              <a href="mailto:kjm980810@gmail.com">kjm980810@gmail.com</a>
            </div>
            <div className="contact-item">
              <FontAwesomeIcon icon={faGlobe} />
              <a href="https://kjms.dev" target="_blank" rel="noreferrer">
                https://kjms.dev
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="sec_05">
        <div className="container">
          <p className="end_text" data-aos="fade-up">
            읽어주셔서 감사합니다.
          </p>
          <p className="end_sub" data-aos="fade-up" data-aos-delay="120">
            문제를 명확히 정의하고, 사용자에게 체감되는 프론트엔드를 꾸준히 만들겠습니다.
          </p>
        </div>
      </section>

      {showPopup && (
        <div className="popup" role="dialog" aria-modal="true" aria-label={`${popupData.pjtName} 프로젝트 상세`}>
          <div className="dim" onClick={popupHide}></div>
          <div className="inner">
            <div className="scroll">
              <div className="title">
                {popupData.pjtName}
                <button type="button" className="popupClose" onClick={popupHide} aria-label="팝업 닫기">
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
              <div className="subTitle">{popupData.subTitle}</div>
              <p className="impactTag">{popupData.impact}</p>
              <div className="summary">{popupData.summary}</div>
              <div className="popup_sections">
                <div className="popup_section">
                  <h4>[기술 스택]</h4>
                  <ul>
                    {popupData.detail.stack.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
                <div className="popup_section">
                  <h4>[주요 기능]</h4>
                  <ul>
                    {popupData.detail.features.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
                <div className="popup_section">
                  <h4>[기술적 포인트]</h4>
                  <ul>
                    {popupData.detail.techPoints.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="img">
                {popupData.images?.length > 0 ? (
                  <Slider {...sliderSettings}>
                    {popupData.images.map((image, index) => (
                      <div key={index}>
                        <img src={image} alt={`${popupData.pjtName}-${index + 1}`} />
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <p>이미지가 없습니다.</p>
                )}
              </div>
              <button
                type="button"
                className="button Link"
                onClick={() => window.open(popupData.url, '_blank', 'noopener,noreferrer')}
              >
                프로젝트 바로가기
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
